{
  "common": {
    "total": "Total: {{count}}",
    "index": "No.",
    "actions": "Actions",
    "actionsLabel": "Actions",
    "createdAt": "Created",
    "createdBy": "Added by",
    "edit": "Edit",
    "delete": "Delete",
    "details": "Details",
    "back": "Back",
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "saved": "Saved",
    "deleted": "Deleted",
    "error": "Something went wrong",
    "loadError": "Could not load the data",
    "retry": "Retry",
    "notFound": "Nothing found",
    "notFoundHint": "Try a different search.",
    "clear": "Clear",
    "required": "Fill in this field",
    "nameTaken": "This name already exists",
    "codeTaken": "This code already exists",
    "system": "System",
    "none": "Not selected",
    "select": "Select",
    "unsavedTitle": "Unsaved changes",
    "unsavedText": "Your input will be lost.",
    "stay": "Stay",
    "leave": "Leave",
    "noRight": "You don't have permission for this action",
    "loading": "Loading..."
  },
  "module": {
    "tabsLabel": "Device management sections",
    "categories": "Device categories",
    "locations": "Device locations",
    "info": "Device information",
    "calibration": "Device calibration",
    "config": "Device configuration"
  },
  "categories": {
    "title": "Device categories",
    "create": "Create category",
    "editTitle": "Edit category",
    "search": "Search by category name",
    "column": "Device category",
    "field": "Category name",
    "placeholder": "Enter a category name",
    "empty": "No categories",
    "emptyHint": "No device category has been added yet.",
    "deleteTitle": "Delete the category?",
    "deleteText": "Category “{{name}}” will be deleted.",
    "inUseTitle": "The category cannot be deleted",
    "inUseText": "{{count}} device(s) belong to this category.",
    "icon": "Icon",
    "color": "Colour"
  },
  "locations": {
    "title": "Device locations",
    "create": "Create location",
    "editTitle": "Edit location",
    "search": "Search by location name",
    "column": "Device location",
    "field": "Location name",
    "placeholder": "Enter a location name",
    "empty": "No locations",
    "emptyHint": "No location has been added yet.",
    "deleteTitle": "Delete the location?",
    "deleteText": "“{{name}}” will be deleted.",
    "deleteInUse": "“{{name}}” will be deleted. {{count}} device(s) will lose their location."
  },
  "info": {
    "title": "Device information",
    "create": "Create device information",
    "editTitle": "Edit device information",
    "search": "Search by device name",
    "category": "Category",
    "location": "Location",
    "name": "Device name",
    "serial": "Serial number",
    "passport": "Passport",
    "passportLong": "Calibration passport",
    "passportBadge": "Passport.{{ext}}",
    "empty": "No devices",
    "emptyHint": "Click “Create device information” to add the first device.",
    "nameLabel": "Choose the device name",
    "namePlaceholder": "Enter a device name",
    "discovered": "Found in data sources",
    "codeLabel": "Device code",
    "codePlaceholder": "Automatic",
    "categoryLabel": "Choose a category",
    "locationLabel": "Choose a location",
    "serialLabel": "Serial number",
    "serialPlaceholder": "Enter the serial number",
    "modelLabel": "Model",
    "modelPlaceholder": "Enter the model",
    "statusLabel": "Status",
    "passportLabel": "Calibration passport",
    "upload": "Upload file",
    "uploading": "Uploading...",
    "replaceFile": "Replace file",
    "removeFile": "Remove file",
    "passportHint": "PDF or image (PNG, JPG), up to 100 MB",
    "fileType": "Only PDF, PNG or JPG files can be uploaded",
    "fileSize": "The file must not exceed 100 MB",
    "created": "Device added",
    "deleteTitle": "Delete the device?",
    "deleteText": "“{{name}}” and its indicators will be deleted. The measurement history is kept.",
    "viewPassport": "View passport"
  },
  "statuses": {
    "active": "Active",
    "inactive": "Inactive",
    "maintenance": "Maintenance"
  },
  "indicators": {
    "title": "Indicators",
    "add": "Add indicator",
    "empty": "No indicators",
    "saveFirst": "Save the device first to add indicators.",
    "createTitle": "New indicator",
    "editTitle": "Edit indicator",
    "name": "Indicator name",
    "namePlaceholder": "E.g. Water level",
    "code": "Code",
    "kind": "Type",
    "physical": "Physical",
    "virtual": "Virtual",
    "unit": "Unit",
    "unitPlaceholder": "E.g. m",
    "precision": "Decimals",
    "thresholds": "Thresholds (criteria)",
    "warningLow": "M-1 low",
    "warningHigh": "M-1 high",
    "alarmLow": "M-2 low",
    "alarmHigh": "M-2 high",
    "alarm": "Alarm monitoring",
    "alarmHint": "Notify when a threshold is crossed",
    "alarmNoRight": "Turning it on needs the edit right of “Devices”",
    "color": "Colour",
    "chartType": "Chart type",
    "channel": "Unified server channel",
    "channelPlaceholder": "e.g. hydro:LEVEL",
    "channelCustom": "Other channel",
    "source": "Source indicator (x)",
    "formula": "Formula",
    "deleteTitle": "Delete the indicator?",
    "deleteText": "“{{name}}” will be deleted.",
    "invalidNumber": "Enter a number",
    "m2High": "The M-2 high threshold must not be below M-1",
    "m2Low": "The M-2 low threshold must not be above M-1",
    "lowHigh": "The low threshold must be below the high one",
    "physicalCount": "{{count}} physical",
    "virtualCount": "{{count}} virtual"
  },
  "chartTypes": {
    "auto": "Auto",
    "line": "Line",
    "bar": "Bar",
    "area": "Area",
    "scatter": "Scatter",
    "step": "Step"
  },
  "colors": {
    "auto": "Auto",
    "custom": "Custom",
    "blue": "Blue",
    "green": "Green",
    "darkGreen": "Dark green",
    "yellow": "Yellow",
    "orange": "Orange",
    "red": "Red",
    "pink": "Pink",
    "purple": "Purple"
  },
  "detail": {
    "title": "Details",
    "category": "Device category",
    "location": "Device location",
    "serial": "Serial number",
    "createdAt": "Created",
    "createdBy": "Created by",
    "code": "Device code",
    "model": "Model",
    "status": "Status",
    "indicators": "Indicators"
  },
  "passport": {
    "title": "Calibration passport",
    "download": "Download",
    "missing": "No passport uploaded",
    "missingHint": "Upload the calibration passport in the device information.",
    "frameTitle": "Calibration passport",
    "fullscreen": "Full screen"
  },
  "calibration": {
    "title": "Device calibration",
    "sourceLabel": "Choose the device indicator",
    "sourcePlaceholder": "Choose an indicator",
    "deviceInfo": "Device information",
    "readingsTitle": "Device readings (from the CSV file)",
    "date": "Date",
    "value": "Reading",
    "noReadings": "No readings yet",
    "formulaTitle": "Formula",
    "formulaLabel": "Enter the formula",
    "formulaPlaceholder": "E.g. 0.0001 * x³ + 0.12 * x + 1",
    "formulaError": "Formula error: {{message}}",
    "formulaHint": "x is the value of the selected indicator",
    "nameLabel": "Indicator name",
    "namePlaceholder": "E.g. Block P - 1 pressure",
    "unitLabel": "Unit",
    "chartLabel": "Chart type",
    "colorLabel": "Colour",
    "newFormula": "New formula",
    "addFormula": "Add a new formula",
    "deleteFormula": "Delete formula",
    "deleteTitle": "Delete the formula?",
    "deleteText": "The virtual indicator “{{name}}” will be deleted.",
    "empty": "No physical indicators",
    "emptyHint": "Add a device and its physical indicator before calibrating.",
    "pickSource": "Choose a physical indicator to calibrate",
    "readOnly": "You don't have permission to change formulas",
    "virtualCount": "Virtual indicators"
  },
  "config": {
    "title": "Device configuration",
    "search": "Search by device name",
    "create": "Add device",
    "code": "Code",
    "name": "Name",
    "category": "Category",
    "location": "Location",
    "source": "Source",
    "lastReading": "Last value",
    "status": "Status",
    "indicators": "Indicators",
    "allCategories": "All categories",
    "allLocations": "All locations",
    "allStatuses": "All statuses",
    "allSources": "All sources",
    "empty": "No devices",
    "categoryFilter": "Filter by category",
    "locationFilter": "Filter by location",
    "statusFilter": "Filter by status",
    "sourceFilter": "Filter by source"
  },
  "sources": {
    "manual": "Manual",
    "unified": "Unified server",
    "csv": "CSV file"
  },
  "monitoring": {
    "tabsLabel": "Data monitoring sections",
    "devicesTab": "Device information",
    "physicalTab": "Physical indicators monitoring",
    "virtualTab": "Virtual indicators monitoring",
    "devicesTitle": "Device information",
    "physicalTitle": "Physical indicators",
    "virtualTitle": "Virtual indicators",
    "search": "Search by device name",
    "filter": "Filter",
    "category": "Category",
    "location": "Location",
    "name": "Device name",
    "serial": "Serial number",
    "passport": "Calibration passport",
    "formula": "Formula",
    "formulaYes": "Yes",
    "formulaNo": "No",
    "deviceName": "Device",
    "device": "Device",
    "time": "Measured at",
    "value": "Value",
    "sourceFile": "Source",
    "unit": "Unit",
    "status": "Status",
    "liveStatus": "Live status: {{status}}",
    "history": "Measurement history",
    "emptyDevices": "No devices",
    "emptyPhysical": "No physical indicators",
    "emptyVirtual": "No virtual indicators",
    "emptyVirtualHint": "Virtual indicators are created with a formula in “Device calibration”.",
    "filterTitle": "Filter",
    "anyCategory": "All categories",
    "anyLocation": "All locations",
    "anyStatus": "All statuses",
    "reset": "Clear",
    "openCalibration": "Go to calibration"
  },
  "history": {
    "title": "Measurement history",
    "range1d": "1 day",
    "range7d": "7 days",
    "range30d": "30 days",
    "rangeAll": "All",
    "rangeLabel": "Period",
    "min": "Min",
    "max": "Max",
    "avg": "Average",
    "last": "Last value",
    "count": "{{count}} measurements",
    "empty": "No measurements in this period",
    "noRight": "You don't have permission to view the history",
    "lastUpdate": "Last update: {{time}}"
  }
}
